import { render, staticRenderFns } from "./NewSocialProofCard.vue?vue&type=template&id=4121fcd4&scoped=true"
import script from "./NewSocialProofCard.js?vue&type=script&lang=js&external"
export * from "./NewSocialProofCard.js?vue&type=script&lang=js&external"
import style0 from "./NewSocialProofCard.scss?vue&type=style&index=0&id=4121fcd4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121fcd4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
